import fetchService from '../../services/api/fetch-locations'
import { useQuery } from 'react-query'
import useCacheKeys from '../use-cache-keys'

const useItems = () => {
    const cacheKeys = useCacheKeys()
    const { data } = useQuery(cacheKeys.LOCATIONS, fetchService, { staleTime: 86400000, cacheTime: 86400000 })
    return [
        data
    ]
}

export default useItems